var _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "#E30A17"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 425,
    cy: 400,
    r: 200,
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475,
    cy: 400,
    r: 160,
    style: {
      fill: "#E30A17"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ffffff"
    },
    points: "583.334,400 764.235,458.779 652.431,304.894 652.431,495.106 764.235,341.221"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr);
export default __webpack_public_path__ + "static/media/tr.69a0293b2c67b5b1cd2fee10843e6cd8.svg";
export { ForwardRef as ReactComponent };